// -*- Mode: rjsx -*-
import React, { useState, useEffect } from 'react';

import Snackbar from '@mui/material/Snackbar';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

import MuiAlert from '@mui/material/Alert';

function Alert(props) {

    if(props === undefined) 
        return null;
    
    return (
          <Snackbar open={props.open} 
                    autoHideDuration={2000} 
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    action={
                        <React.Fragment>
                          <IconButton size="small" aria-label="close" color="inherit" onClick={props.onClose}>
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </React.Fragment>
                    }            
                    onClose={props.onClose} >
            <MuiAlert elevation={6} variant="filled" {...props} >{props.children}</MuiAlert>
        </Snackbar>
    );
    
}


function Success(props) {
    return <Alert severity="success" {...props} />;
}

function Info(props) {
    return <Alert severity="info" {...props} />;
}

function Warning(props) {
    return <Alert severity="warning" {...props} />;
}

function Error(props) {
    return <Alert severity="error" {...props} />;
}

export { Success, Info, Warning, Error };
export default Alert; 


